import { ChangeDetectionStrategy, Component, input, output, computed } from '@angular/core';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { HistoryListComponent } from '@shared/components/history-list/history-list.component';
import {
  ClientCompanyResponse,
  ClientConfigurationResponse,
  ClientTransactionHistoryResponse,
} from '../../client.model';
import { CompanyResponse } from '@features/company/company.model';
import { SHARED_IMPORTS } from '@shared/modules/shared-imports.module';
import { DataTableColumn } from '@shared/components/data-table.component';
import { ClientActions } from '../client-table/client-actions-enum';
import { useClientActionMenu } from '../client-table/client-action-menu-composable';

@Component({
  selector: 'client-config-panel',
  imports: [HistoryListComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './client-config-panels.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientConfigPanelsComponent {
  readonly ClientActions = ClientActions;
  readonly canManage = input(false);
  readonly data = input<any[]>([]);
  readonly detailsTitle = input<string>('Title');
  readonly manageConfiguration = output<{
    configuration?: ClientConfigurationResponse;
    action: ClientActions.Create | ClientActions.Edit | ClientActions.Toggled;
  }>();
}